import CustomCard from "common/custom-card/CustomCard";
import { Col, Row } from "components/common";
import { Wrapper } from "./HomePage.styled";
import Banner from "./new-banner/Banner";
import BuilderRankCard from "./rank/builderRankCard/BuilderRankCard";
import DailyPECard from "./rank/dailyPECard/DailyPECard";
import DailyTECard from "./rank/dailyTECard/DailyTECard";
import PromoterRankCard from "./rank/promoterRankCard/PromoterRankCard";
import BusinessSnapshotCard from "./businessSnapshot/businessSnapshotCard";
import ShopNuevaImage from "../../assets/images/shop nueva.png";
import ShopBodyImage from "../../assets/images/shop body.png";
import { useSelector } from "react-redux";
import { getToken } from "utils/auth";
import MaxLegWidget from "./maxLegWidget/MaxLegWidget";
import AlertSection from "./alert/AlertSection";

export default function IndexPage() {
  const myUser = useSelector((state) => state.auth.user);
  const token = getToken();

  return (
    <Wrapper>
      <Row className="d-flex" gutter={[24, 24]}>
        {myUser.type == 1 && (
          <Col span={24}>
            <AlertSection />
          </Col>
        )}
        {/* Banner */}
        <Col xs={24}>
          <CustomCard>
            <Banner />
          </CustomCard>
        </Col>

        {/* Rank Cards */}
        {myUser.type == 1 ? (
          <>
            <Col xs={24} xl={8}>
              <PromoterRankCard />
            </Col>
            <Col xs={24} xl={8}>
              <BuilderRankCard />
            </Col>
            <Col xs={24} xl={8}>
              <BusinessSnapshotCard />
            </Col>
            <Col xs={24} xl={12}>
              <MaxLegWidget />
            </Col>
            {/* Chart Cards */}
            <Col xs={24} xl={12}>
              <DailyPECard />
            </Col>
            <Col xs={24} xl={12}>
              <DailyTECard />
            </Col>
          </>
        ) : (
          <>
            <Col xs={12}>
              <div className="banner-button">
                <img
                  src={ShopNuevaImage}
                  alt="Slide 1"
                  onClick={() => {
                    window.open(
                      `${process.env.REACT_APP_CORP_URL}/login?auto-token-login&token=${token}`,
                      "_blank"
                    );
                  }}
                />
              </div>
            </Col>
            <Col xs={12}>
              <div className="banner-button">
                <img
                  src={ShopBodyImage}
                  alt="Slide 1"
                  onClick={() => {
                    window.open(
                      `https://bodynbeauty.com/login?auto-token-login&token=${token}`,
                      "_blank"
                    );
                  }}
                />
              </div>
            </Col>
          </>
        )}
      </Row>
    </Wrapper>
  );
}
